import { MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const ADDRESS =
  "Shop No 6, Shantinath Vaibhav Building, Chardhar Nagar, Hanuman Nagar Road, Nallasopara West, Maharashtra 401203";

const MAP_SRC =
  "https://maps.google.com/maps?q=" +
  encodeURIComponent(
    "Shantinath Vaibhav Building, Chardhar Nagar, Hanuman Nagar Road, Nallasopara West, Maharashtra 401203"
  ) +
  "&t=&z=16&ie=UTF8&iwloc=&output=embed";

export const MapSection = () => (
  <section id="location" className="scroll-mt-24 border-t border-white/10 bg-[#0B0C0E] py-24" data-testid="map-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-12 flex flex-wrap items-end justify-between gap-6">
        <div>
          <Eyebrow>Find us</Eyebrow>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase tracking-tight text-[#F3F4F6] sm:text-5xl">
            Visit <span className="text-[#FFFFFF]">our office.</span>
          </h2>
        </div>
        <p className="flex max-w-sm items-start gap-3 text-sm leading-relaxed text-[#9CA3AF]">
          <MapPin size={18} className="mt-0.5 shrink-0 text-[#FFFFFF]" />
          <span data-testid="office-address">{ADDRESS}</span>
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="relative border border-[#2E333D]">
          <div className="absolute -left-2 -top-2 h-10 w-10 border-l-2 border-t-2 border-[#FFFFFF]" aria-hidden="true" />
          <div className="absolute -bottom-2 -right-2 h-10 w-10 border-b-2 border-r-2 border-[#FFFFFF]" aria-hidden="true" />
          <iframe
            title="Gativan Office — Shop No 6, Shantinath Vaibhav Building, Nallasopara West"
            data-testid="map-iframe"
            src={MAP_SRC}
            className="h-[420px] w-full grayscale-[60%] invert-[92%] hue-rotate-180 contrast-[0.9]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
